var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 8.32356L5.25 7L7.48337 14L26.25 8.32356Z",
    fill: "#00AFB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63334 20.229C7.62168 20.229 7.61073 20.2321 7.59906 20.2329C7.44711 19.6942 7.32096 19.2439 7.32096 19.2439L3.63245 5.67437C3.63881 5.69431 3.64163 5.71345 3.6427 5.73339L3.62857 5.67956C3.62786 5.67636 3.62786 5.67397 3.62644 5.67158C3.52114 5.36093 3.14586 5.18307 2.36843 5.27359C1.58995 5.36413 1.72635 5.68913 1.83202 6.00017L6.91104 20.5352C6.67146 20.7661 6.51632 21.1055 6.51632 21.4894C6.51632 22.1853 7.01635 22.75 7.63334 22.75C8.25033 22.75 8.75 22.1853 8.75 21.4894C8.75 20.7932 8.25033 20.229 7.63334 20.229Z",
    fill: "#FF7500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFgLogoIcon);
export default __webpack_public_path__ + "static/media/fg-logo-icon.b4bc4af4bdd589aa8ac380c3b5adb944.svg";
export { ForwardRef as ReactComponent };